/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wide_Wise_Bull_MarchInputs */

const en_wide_wise_bull_march = /** @type {(inputs: Wide_Wise_Bull_MarchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neutrals`)
};

const de_wide_wise_bull_march = /** @type {(inputs: Wide_Wise_Bull_MarchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passive`)
};

/**
* | output |
* | --- |
* | "Neutrals" |
*
* @param {Wide_Wise_Bull_MarchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wide_wise_bull_march = /** @type {((inputs?: Wide_Wise_Bull_MarchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wide_Wise_Bull_MarchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wide_wise_bull_march(inputs)
	return de_wide_wise_bull_march(inputs)
});